import React from 'react';
import { PromoBar } from '../components/PromoBar';
import { Hero } from '../components/Hero';
import { ProofStrip } from '../components/ProofStrip';
import { PainSection } from '../components/PainSection';
import { SystemSection } from '../components/SystemSection';
import { VolumesSection } from '../components/VolumesSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { FinalSection } from '../components/FinalSection';
import { SiteFooter } from '../components/SiteFooter';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function Landing() {
  return <div className="w-full bg-cream" data-id="element-290" data-mp="m83iih9cprpb">
      <PromoBar data-id="element-291" data-mp="2a0ks8zecq8b" />
      <Hero data-id="element-292" data-mp="2ajrsunidu7k" />
      <main data-id="element-293" data-mp="2aaarwkfyxe0">
        <ProofStrip data-id="element-294" data-mp="2atk4ow10dgf" />
        <PainSection data-id="element-295" data-mp="2bbqiecek822" />
        <SystemSection data-id="element-296" data-mp="27nwzf6yjlnc" />
        <VolumesSection data-id="element-297" data-mp="3tftloxemismg" />
        <BonusSection data-id="element-298" data-mp="3tfjvb8po2jg8" />
        <OfferSection data-id="element-299" data-mp="3tf0dds00nv27" />
        <TestimonialsSection data-id="element-300" data-mp="3peq7efc854nc" />
        <GuaranteeSection data-id="element-301" data-mp="3pdyc75mjh8xl" />
        <FaqSection data-id="element-302" data-mp="3pf9q3y9p7x2f" />
        <BeforeAfterSection data-id="element-303" data-mp="3pguaiv2atzmk" />
        <FinalSection data-id="element-304" data-mp="3kfwtilt0zbmn" />
      </main>
      <SiteFooter data-id="element-305" data-mp="3kgyfvmfhrkjo" />
      <WhatsAppButton data-id="element-306" data-mp="3khhm45vs4khv" />
    </div>;
}